import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SHIPPING_RATE_LISTING,
    ADD_SHIPPING_RATE,
    UPDATE_SHIPPING_RATE,
    DELETE_SHIPPING_RATE,
    EXPORT_SHIPPING_RATE,
    GET_SHIPPING_RATE_DETAILS,
} from "./actionTypes.js";

import {
    getShippingRateListingSuccess,
    getShippingRateListingFail,
    createShippingRateSuccess,
    createShippingRateFail,
    updateShippingRateSuccess,
    updateShippingRateFail,
    deleteShippingRateSuccess,
    deleteShippingRateFail,
    exportShippingRateSuccess,
    exportShippingRateFail,
    getShippingRateDetailsFail,
    getShippingRateDetailsSuccess,
} from "./actions.js";

import {
    shippingRateListingApi,
    updateShippingRateApi,
    deleteShippingRateApi,
    exportShippingRateApi,
    shippingRateDetailsApi,
    addShippingRateApi,
} from "./shippingRateApi.js";

function* fetchShippingRateListing({ payload }) {
    try {
        const response = yield call(shippingRateListingApi, payload);
        yield put(getShippingRateListingSuccess(response));
    } catch (error) {
        yield put(getShippingRateListingFail(error));
    }
}

function* fetchShippingRateDetail({ payload }) {
    try {
        const response = yield call(shippingRateDetailsApi, payload);
        yield put(getShippingRateDetailsSuccess(response));
    } catch (error) {
        yield put(getShippingRateDetailsFail(error));
    }
}

function* createShippingRate({ payload }) {
    try {
        const response = yield call(addShippingRateApi, payload);
        yield put(createShippingRateSuccess(response));
    } catch (error) {
        yield put(createShippingRateFail(error));
    }
}

function* updateShippingRate({ payload }) {
    try {
        const response = yield call(updateShippingRateApi, payload);
        yield put(updateShippingRateSuccess(response));
    } catch (error) {
        yield put(updateShippingRateFail(error));
    }
}

function* deleteShippingRate({ payload }) {
    try {
        const response = yield call(deleteShippingRateApi, payload);
        yield put(deleteShippingRateSuccess(response));
    } catch (error) {
        yield put(deleteShippingRateFail(error));
    }
}

function* exportShippingRate({ payload }) {
    try {
        const response = yield call(exportShippingRateApi, payload);
        yield put(exportShippingRateSuccess(response));
    } catch (error) {
        yield put(exportShippingRateFail(error));
    }
}

function* ShippingRateSaga() {
    yield takeEvery(GET_SHIPPING_RATE_LISTING, fetchShippingRateListing);
    yield takeEvery(GET_SHIPPING_RATE_DETAILS, fetchShippingRateDetail);
    yield takeEvery(ADD_SHIPPING_RATE, createShippingRate);
    yield takeEvery(UPDATE_SHIPPING_RATE, updateShippingRate);
    yield takeEvery(DELETE_SHIPPING_RATE, deleteShippingRate);
    yield takeEvery(EXPORT_SHIPPING_RATE, exportShippingRate);

}

export default ShippingRateSaga
